import ReactLoading from 'react-loading';
export default function Loading({type, color}){
  const style = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%"
  }
  return (
    <div style={style}>
      <ReactLoading type={type} color={color} height={'50px'} width={'50px'} />
    </div>
  )
}